import { cn } from '../../lib/utils';
import DataViewLoader from './DataViewLoader';
import { useCurrency } from '../../hooks/useCurrency';
import dayjs from 'dayjs';

interface DataViewProps {
  loading: boolean;
  records: Array<any>;
  config: DataViewConfig;
  onClick?: (data: any) => void,
}

function DataView({records, loading, config, onClick}: DataViewProps) {
  const [formatCurrency] = useCurrency();

  const handleClick = (data: any) => {
    onClick!(data)
  }

  const hasRecords = records.length > 0 && !loading;
  const emptyRecords = !records.length && !loading;

  const getNextField = (col: DataViewConfigItem, data: { [x: string]: any }) => {
    if (col.nestedField) {
      return data[col.field]?.[col.nestedField] ?? '-'
    }
    return data[col.field] != null ? data[col.field] : '-'
  }

  const displayColData = (col: DataViewConfigItem, record: any) => {
    if (col.dataType === 'amount') {
      return formatCurrency(getNextField(col, record))
    } else if (col.dataType === 'date') {
      const dateValue = getNextField(col, record);
      return dateValue !== '-' ? dayjs(dateValue).format("DD/MM/YYYY") : '-';
    }

    return getNextField(col, record)
  } 

  return (
    <div className="mb-4">
      <div className="space-y-3 p-1">
          {hasRecords && records.map((record, index) => (<div key={index} className="grid grid-cols-2 p-6 border border-gray-200 rounded-md shadow" onClick={() => handleClick(record)}>
              {config.items.map((configItem, idx) => (<div
                key={configItem.field}
                className={cn("flex items-center mb-3", idx % 2 !== 0 ? "justify-end text-right" : "")}
              >
                <div className="flex flex-col gap-1">
                    <span className="font-light text-400 text-sm">{ configItem.title }</span>
                    <span className="text-sm font-semibold">
                      {displayColData(configItem, record)}
                    </span>
                </div>
            </div>))}
          </div>
          ))}
      </div>
      {emptyRecords && (<p className="text-center">No Data Found</p>)}
      {loading && (<DataViewLoader />)}
    </div>
  )
}

export default DataView